import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router";
import { useAuth, AuthenticationStatus } from "../../../context/auth-context";
// import { HomeNav } from "../../nav/homeNav";
import { isMobile } from "react-device-detect";
import { Logger } from "aws-amplify";
import { authRedirectPath, loginPath } from "../../main";
import * as yup from "yup";
import { useSmallScreen } from "../../../hooks/useWindowSize";
import { Button } from "../../../tabin/components/button";
import { Input } from "../../../tabin/components/input";

const logger = new Logger("newInformationRequired");

const firstNameSchema = yup.string().required("Please enter your first name");
const lastNameSchema = yup.string().required("Please enter your last name");
const passwordSchema = yup.string().min(8, "Password must be at least 8 characters long").required("Please enter a password");

export default () => {
    const { email, completeNewPassword } = useAuth();
    const { isSmallScreen } = useSmallScreen();
    const navigate = useNavigate();

    const [loading, setLoading] = useState(false);
    const [firstName, setFirstName] = useState("");
    const [lastName, setLastName] = useState("");
    const [password, setPassword] = useState("");

    const [serverError, setServerError] = useState("");
    const [firstNameError, setFirstNameError] = useState("");
    const [lastNameError, setLastNameError] = useState("");
    const [passwordError, setPasswordError] = useState("");

    const { status } = useAuth();

    useEffect(() => {
        if (status === AuthenticationStatus.Unauthenticated) {
            navigate(loginPath, { replace: true });
        }

        if (status === AuthenticationStatus.SignedIn) {
            navigate(authRedirectPath);
        }
    }, [status]);

    const onChangeFirstName = (event: React.ChangeEvent<HTMLInputElement>) => {
        setFirstName(event.target.value);
        setFirstNameError("");
        setServerError("");
    };

    const onChangeLastName = (event: React.ChangeEvent<HTMLInputElement>) => {
        setLastName(event.target.value);
        setLastNameError("");
        setServerError("");
    };

    const onChangePassword = (event: React.ChangeEvent<HTMLInputElement>) => {
        setPassword(event.target.value);
        setPasswordError("");
        setServerError("");
    };

    const onSignUp = async () => {
        setLoading(true);
        let fieldsValid = true;

        try {
            await firstNameSchema.validate(firstName);
            setFirstNameError("");
        } catch (e) {
            setFirstNameError(e.message);
            fieldsValid = false;
        }

        try {
            await lastNameSchema.validate(lastName);
            setLastNameError("");
        } catch (e) {
            setLastNameError(e.message);
            fieldsValid = false;
        }

        try {
            await passwordSchema.validate(password);
            setPasswordError("");
        } catch (e) {
            setPasswordError(e.message);
            fieldsValid = false;
        }

        if (fieldsValid) {
            try {
                await completeNewPassword(password, firstName, lastName);
                logger.debug("Successfully logged in");
                setLoading(false);
            } catch (e) {
                logger.debug("e", e);
                setServerError(e.message);
                setLoading(false);
            }
        } else {
            setLoading(false);
        }
    };

    const onEnter = (e: React.KeyboardEvent<HTMLInputElement>) => {
        if (e.key === "Enter") {
            onSignUp();
        }
    };

    const firstNameInput = (
        <>
            <Input
                name="firstName"
                label="First Name"
                type="text"
                onChange={onChangeFirstName}
                onKeyPress={onEnter}
                value={firstName}
                error={firstNameError}
            />
        </>
    );

    const lastNameInput = (
        <>
            <Input
                name="lastName"
                label="Last Name"
                type="text"
                onChange={onChangeLastName}
                onKeyPress={onEnter}
                value={lastName}
                error={lastNameError}
            />
        </>
    );

    const passwordInput = (
        <>
            <Input
                name="password"
                label="Password"
                type="password"
                onChange={onChangePassword}
                onKeyPress={onEnter}
                value={password}
                error={passwordError}
            />
        </>
    );

    const loginButton = (
        <>
            <Button style={{ borderRadius: "8px", width: "100%", height: "52px" }} disabled={loading} onClick={onSignUp} loading={loading}>
                <div className="text-bold">LOG IN</div>
            </Button>
        </>
    );

    const content = (
        <>
            <div
                style={
                    !isSmallScreen
                        ? {
                              padding: "24px",
                              margin: "0 auto",
                              width: "448px",
                              border: "1px solid #e4e4e4",
                          }
                        : {}
                }
            >
                <div className="h2">Information required</div>
                <div className="mb-3"></div>
                <div>Please enter the following information to finish setting up of your account.</div>
                <div className="mb-3"></div>
                {serverError && <div className="text-error mb-3">{serverError}</div>}

                <div className="mb-2"></div>
                {firstNameInput}
                <div className="mb-2"></div>
                {lastNameInput}
                <div className="mb-2"></div>
                {passwordInput}
                <div className="mb-3"></div>
                {loginButton}
            </div>
        </>
    );

    return (
        <>
            {/* <HomeNav /> */}
            <div
                style={{
                    minHeight: "100vh",
                    maxWidth: "1080px",
                    margin: "auto",
                    padding: "24px",
                    paddingTop: isSmallScreen ? "24px" : "40px",
                    paddingBottom: isMobile ? "80px" : "unset", // for tab nav
                }}
            >
                {content}
            </div>
        </>
    );
};
